import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class CommSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getCommSearch(data);
    }
}
export default CommSearchUseCase;
